import { render, staticRenderFns } from "./shareDeailGraphV_2.vue?vue&type=template&id=27fd35d0&scoped=true&"
import script from "./shareDeailGraphV_2.vue?vue&type=script&lang=js&"
export * from "./shareDeailGraphV_2.vue?vue&type=script&lang=js&"
import style0 from "./shareDeailGraphV_2.vue?vue&type=style&index=0&id=27fd35d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd35d0",
  null
  
)

export default component.exports